<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2 class="font-weight-bold mb-4">Timesheets for week {{ payweek_start_date }} - {{ payweek_end_date }}</h2>
      </div>
    </div>

    <hr class="mt-4 mb-1" style="border-color: #e6007e">
    <hr class="mt-1 mb-4" style="border-color: #e6007e">

    <ready_timesheets :dt_reload="dt_reload"></ready_timesheets>
  </div>
</template>
<script>
// load datatable components
import ready_timesheets from "./timesheets/timesheets_ready_to_export";

const taxYear = require('tax-year');
const today = new Date();
const calculator = taxYear();

export default {
  name: "timesheets_this_week",
  props: {},
  components: {
    // Table,
    ready_timesheets
  },
  data() {
    return {
      dt_reload: 0,

      payweek_start_date: this.$moment.utc().startOf('isoWeek').subtract(1, 'week').format("[(]ddd[)] DD/MM/YYYY"),
      payweek_end_date: this.$moment.utc().endOf('isoWeek').subtract(1, 'week').format("[(]ddd[)] DD/MM/YYYY"),

      ready_timesheets: [],
    }
  },
  created() {
    this.$bus.$on('download_timesheets', ($event) => {
      this.dt_reload = $event;
    });
  },
}
</script>
